import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { loadMetaPixel, trackPageView } from "@/lib/metaPixel";

// Loads the Meta Pixel once and sends a PageView on every client-side route change.
const MetaPixelTracker = () => {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    loadMetaPixel();
  }, []);

  useEffect(() => {
    const current = location.pathname + location.search + location.hash;
    if (lastPath.current === current) return; // dev StrictMode double-run
    const isFirst = lastPath.current === null;
    lastPath.current = current;
    // The loader already sent the initial PageView — avoid a duplicate.
    if (isFirst) return;
    trackPageView();
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default MetaPixelTracker;
